import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import notify from '~/utils/notify';
import IAgency from '../interfaces/IAgency';
import { useHookstate } from '@hookstate/core';

export default function Edit() {     
  const { register, handleSubmit, control, setValue: setFormValue, getValues, watch, resetField } = useForm<IAgency>();

    const fields = [
      { name: 'id', type: 'hidden'},
      { name: 'name', type: 'string', required: true,},
      { name: 'acronym', type: 'string', required: true},
      { name: 'area_plan_id', type: 'selectAutoComplete', model: 'area-plan', placeholder: 'Mapa', required: true },
      { name: 'can_manage_any_agency', type: 'switch', checked: true, placeholder: 'Pode administrar qualquer agência', required: true, helperText: 'Com esse campo ativo, usuários desta agência poderão ter acesso, através do menu de Administração, de cadastros pertencentes a qualquer agência (como Usuários e Dispositivos). Caso contrário, informar quais agências ela poderá administrar, além dela mesma.' },
      { name: 'agencies_managed', type: 'selectAutoCompleteMultiple', model: 'agency', placeholder: 'Agencies to be managed' },
  ];
    
    return(
      <CrudEdit 
        model={'agency'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        setFormValue={setFormValue}
        messageSuccess={'Agency successfully updated!'}  
        title={'Edit agency'} 
        getValues={getValues}
        watch={watch}
        resetField={resetField}
      />
    )
}
